import { Role } from "../models/Role";
const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

const getRoles = async (): Promise<Role[]> => {
  const response = await fetch(`${API_BASE_URL}/Role/GetAll`);
  const data = await response.json();
  return data;
};

const RoleService = {
    getRoles
}

export default RoleService